(function () {
    'use strict';
    angular
        .module('plagiat2017App')
        .constant('INVOICE_STATUS_CONSTANT', function() {
                var constant = {
                    INVOICE_STATUS_NEW: {name: 'NEW', id: 0, langKey : 'payments.invoice.status.0'},
                    INVOICE_STATUS_PAID: {name: 'PAID', id: 1, langKey : 'payments.invoice.status.1'},
                    INVOICE_STATUS_ISSUED: {name: 'ISSUED', id: 2, langKey : 'payments.invoice.status.2'},
                    INVOICE_STATUS_WAITING: {name: 'WAITING', id: 3, langKey : 'payments.invoice.status.3'},
                    INVOICE_STATUS_INCORRECT: {name: 'INCORRECT', id: 4, langKey : 'payments.invoice.status.4'}
                };
                constant.arrayOfValues = [constant.INVOICE_STATUS_NEW, constant.INVOICE_STATUS_PAID, constant.INVOICE_STATUS_ISSUED,
                    constant.INVOICE_STATUS_WAITING, constant.INVOICE_STATUS_INCORRECT];
                return constant;
            }()
        )
    ;
})();